module.exports = __webpack_public_path__ + "img/slideshow_5.696ee265.jpg";